export default "__VITE_ASSET__aeca642d__"